// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 152 ? "about" : chunkId) + "." + {"92":"dfd52c31","152":"3795fcf8","540":"d014e5e0","680":"090e0104","736":"d9216e55"}[chunkId] + ".js";
};